import { useState } from "react";
import type { ListerProposal } from "../../../lib/api";

export default function TagEditor({ tags, rejected, vocab, onAdd, onRemove, onToggleNew }: { tags: ListerProposal["tags"]; rejected: string[]; vocab: string[]; onAdd: (v: string) => void; onRemove: (v: string) => void; onToggleNew: (v: string) => void }) {
  const [draft, setDraft] = useState("");
  return (
    <div className="space-y-2 font-mono text-sm">
      <div className="flex flex-wrap gap-1">
        {tags.map((t) => {
          const off = t.is_new && rejected.includes(t.value);
          return (
            <span key={t.value} className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded border ${t.is_new ? (off ? "border-zinc-800 text-zinc-600 line-through" : "border-amber-600 text-amber-200") : "border-zinc-700 text-zinc-200"}`}>
              {t.value}{t.is_new && <span className="text-[10px] opacity-70">new</span>}
              {t.is_new ? <button aria-label={`toggle new tag ${t.value}`} onClick={() => onToggleNew(t.value)} className="ml-1 p-2 -m-1">{off ? "↺" : "✕"}</button> : <button aria-label={`remove tag ${t.value}`} onClick={() => onRemove(t.value)} className="ml-1 p-2 -m-1">✕</button>}
            </span>
          );
        })}
      </div>
      <div className="flex gap-2">
        <input list="tag-vocab" value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && draft.trim()) { onAdd(draft); setDraft(""); } }} placeholder="add tag…" className="flex-1 bg-zinc-950 border border-zinc-800 rounded px-3 py-2" />
        <datalist id="tag-vocab">{vocab.map((v) => <option key={v} value={v} />)}</datalist>
        <button onClick={() => { if (draft.trim()) { onAdd(draft); setDraft(""); } }} className="bg-zinc-800 hover:bg-zinc-700 px-3 py-2 rounded">add</button>
      </div>
    </div>
  );
}
